<template>
    <div>
        <Form :user="user" :nBox="nBox" />
        <List :user="user" :nBox="nBox" />
    </div>
</template>
<script>
import { Form, List } from './components'
export default {
    components: {
        Form,
        List,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        nBox: {
            type: Object,
            required: true,
        },
    },
}
</script>
